import React from "react";
import { EmailUnsubscribeLayout } from "./EmailUnsubscribeLayout";

export const EmailUnsubscribeInvalidScreen: React.FC = () => (
  <EmailUnsubscribeLayout
    title="Your unsubscribe link has expired"
    subtitle={
      <>
        Please find an unsubscribe link from your most recent email or reach out
        to us at{" "}
        <a className="underline" href="mailto:support@poweredbylight.com">
          support@poweredbylight.com
        </a>
        .
      </>
    }
  />
);
